<template>
    <div class="z-dialog">
        <el-dialog v-model="dialogShow" :title="dialogTitle" :width="obj.dialogWidth" :before-close="close"
            :close-on-click-modal="false" destroy-on-close :alignCenter="true" :append-to-body="appendtobody">
            <slot> </slot>
            <template #footer v-if="obj.dialogIsFooter">
                <span class="dialog-footer">
                    <el-button class="btn" @click="success">{{
                        obj.dialogSuccessBtnText
                    }}</el-button>
                    <!-- <el-button
                        class="btn btn-mixins-clear-default"
                        @click="close"
                        >{{ obj.dialogCloseBtnText }}</el-button
                    > -->
                </span>
            </template>
        </el-dialog>
    </div>
</template>
 
<script>
import { computed } from 'vue';
export default {
    props: {
        dialogObject: {
            default() {
                return {};
            },
            type: Object,
        },
        appendtobody: {
            default: false,
            type: Boolean
        }
    },
    emits: ['dialogClose', 'dialogSuccess'],
    setup(props, ctx) {
        // const dialogObj = reactive(inject('dialogObj'))
        // 处理props的数据 重新定义 dialogVisible
        const dialogShow = computed({
            get() {
                // getter
                return props.dialogObject.dialogVisible;
            },
            set(val) {
                return val;
            },
        });

        const dialogTitle = computed({
            get() {
                // getter
                return props.dialogObject.title;
            },
            set(val) {
                return val;
            },
        });
        const obj = {
            dialogTitle: props.dialogObject.title || '标题',
            dialogWidth: props.dialogObject.width || '30%',
            dialogCloseBtnText: props.dialogObject.closeBtnText || '取消',
            dialogSuccessBtnText: props.dialogObject.successBtnText || '成功',
            dialogIsFooter: props.dialogObject.isFooter || false,
        };
        const close = () => {
            ctx.emit('dialogClose', false, 'close');
        };
        const success = () => {
            ctx.emit('dialogSuccess', false, 'success');
        };
        return { obj, dialogShow, dialogTitle, close, success };
    },
};
</script>
<style lang="scss">
.z-dialog {
    z-index: 999999;

    .el-overlay {
        z-index: 1030 !important;
    }

    .el-dialog {
        // top: 50%;
        // transform: translateY(-50%);
        // margin: 0 auto;
    }

    .el-dialog__header {
        background: #f5f5f5;
        padding: 11px 20px;
        height: 40px;
        box-sizing: border-box;
        margin-right: 0;

        .el-dialog__title {
            font-size: 14px;
            line-height: 18px;
            color: $font-color-txt;
            font-weight: 700;
        }
    }

    .dia-suc {
        margin-left: 16px !important;
    }

    .el-dialog__headerbtn {
        width: 40px;
        height: 40px;
        top: 3px;

        .el-dialog__close {
            width: 18px;
            height: 18px;
            color: #333;
            font-weight: 600;

            svg {
                width: 18px;
                height: 18px;
            }
        }
    }

    .el-dialog__footer {
        text-align: center;

        .dialog-footer {
            text-align: center;

            .btn {
                padding: 7px 42px;
                width: 112px;
                height: 32px;
                background: $font-auxiliary-color;
                border: 1px solid $font-auxiliary-color;
                border-radius: 2px;
                box-sizing: border-box;
                color: #fff;
            }
        }
    }
}

.private * {
    font-weight: revert;
    font-size: revert;
    font-style: revert;
}</style>